var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',{staticClass:"global-notice"},[_c('el-icon',{attrs:{"icon":"warning"}}),_vm._v("\n  我是一段提示信息\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }